import { render } from "./TheAlert.vue?vue&type=template&id=5a9a9572&scoped=true&lang=pug"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"

import "./TheAlert.vue?vue&type=style&index=0&id=5a9a9572&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9a9572"]])

export default __exports__